import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  HeatingConfigurationRegulationProperties,
  CallForHeatDemandProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsStringValueProperty,
  DcSensorValueProperties,
  HeatingCurveProperties,
  HeatingCurveCommands,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-call-for-heat-heating-zone-details-overlay',
  templateUrl: './call-for-heat-heating-zone-details-overlay.component.html',
  styleUrls: ['./call-for-heat-heating-zone-details-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallForHeatHeatingZoneDetailsOverlayComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;

  heatingCurve$: Observable<Feature<HeatingCurveProperties, HeatingCurveCommands>>;
  heatingDemand$: Observable<Feature<CallForHeatDemandProperties, never>>;
  heatingCurvePresets$: Observable<Feature<IsStringValueProperty, never>>;
  heatingConfigurationRegulation$: Observable<
    Feature<HeatingConfigurationRegulationProperties, never>
  >;
  heatingSensorsTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  operatingProgramName$: Observable<string>;

  constructor(public installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.heatingDemand$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatDemand
    );
    this.heatingCurvePresets$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatHeatingCurvePresets
    );
    this.heatingConfigurationRegulation$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatConfigurationRegulation
    );
    this.heatingSensorsTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatSensorsTemperature
    );
    this.heatingCurve$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatHeatingCurve
    );
  }
}
